var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOffline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Icon_interface_offline",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "error_FILL1_wght400_GRAD0_opsz48",
    d: "M87.5,187.25a.608.608,0,1,0-.441-.178A.6.6,0,0,0,87.5,187.25Zm-.506-2.869h1.125v-4.744H86.994ZM87.5,191a7.259,7.259,0,0,1-2.916-.591,7.576,7.576,0,0,1-4-4,7.507,7.507,0,0,1,0-5.837,7.5,7.5,0,0,1,1.613-2.378,7.7,7.7,0,0,1,2.388-1.6,7.506,7.506,0,0,1,5.837,0,7.5,7.5,0,0,1,3.981,3.984,7.5,7.5,0,0,1,0,5.836,7.66,7.66,0,0,1-1.6,2.383,7.571,7.571,0,0,1-2.381,1.612A7.254,7.254,0,0,1,87.5,191Z",
    transform: "translate(-80 -176)",
    fill: "#d37423"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOffline);
export default __webpack_public_path__ + "static/media/icon-offline.d745de506b13609bddad6d0859d9669a.svg";
export { ForwardRef as ReactComponent };